"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
var _DateInputValidator = _interopRequireDefault(require("./DateInputValidator"));
var _DateFormatter = _interopRequireDefault(require("../../common/Formatters/DateFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.date-input {\n  margin-bottom: 1.5rem; }\n  .date-input .bx--label {\n    color: #4c4c4c; }\n  .date-input .bx--date-picker__input {\n    font-family: Helvetica; }\n  .date-input .tooltip {\n    color: #a8a8a8; }\n  .date-input .bx--form-requirement {\n    width: 18rem; }\n";
  const fileName = "DateInput_DateInput";
  const element = document.querySelector("style[data-sass-component='DateInput_DateInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const DateInput = props => {
  const calenderDropdownCarbonDatePickerType = 'single';
  const shortFlatpickrDayToken = 'j';
  const shortFlatpickrMonthToken = 'n';
  const longFlatpickrYearToken = 'Y';
  const flatpickrDateFormat = `${shortFlatpickrDayToken}.${shortFlatpickrMonthToken}.${longFlatpickrYearToken}`;
  const isMaximumDateValid = value => {
    const maximumDate = new Date(_DateFormatter.default.formatForApi(props.maximumDate));
    const valueDate = new Date(_DateFormatter.default.formatForApi(value));
    return maximumDate >= valueDate;
  };
  const validate = value => {
    const errors = {};
    if (!_DateInputValidator.default.validatePattern(value)) {
      errors.pattern = props.invalidPatternText;
    }
    if (props.maximumDate && !isMaximumDateValid(value)) {
      errors.maximumDate = 'error.input';
    }
    return errors;
  };
  const onType = event => {
    const value = event.target.value;
    onChange(event, value);
  };
  const onClickCalendarDate = event => {
    const value = document.getElementById(props.id).value;
    onChange(event, value);
  };
  const getError = value => {
    if (!value) {
      return;
    }
    const errors = validate(value);
    return errors.maximumDate ? errors.maximumDate : errors.pattern;
  };
  const onChange = (event, value) => {
    props.onChange(event, value, getError(value));
  };
  const onBlur = e => {
    if ((!e.relatedTarget || !e.relatedTarget.classList.contains('flatpickr-day')) && props.value && props.onBlur) {
      props.onBlur(e);
    }
  };
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'date-input'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.DatePicker, {
    dateFormat: flatpickrDateFormat,
    datePickerType: calenderDropdownCarbonDatePickerType,
    onChange: onClickCalendarDate,
    maxDate: props.maximumDate
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.DatePickerInput, {
    pattern: null // to avoid browser default tooltip "Please match the requested format"
    ,
    id: props.id,
    labelText: customLabel,
    onChange: onType,
    placeholder: props.placeholder,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    value: props.value,
    onBlur: onBlur
  })));
};
DateInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  invalidPatternText: _propTypes.default.string.isRequired,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  invalidText: _propTypes.default.string,
  type: _propTypes.default.string,
  maximumDate: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  tooltip: _propTypes.default.string
};
DateInput.defaultProps = {
  type: 'DateInput' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = DateInput;